(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const drawer = document.getElementById('drawer');
  const backdrop = document.getElementById('backdrop');
  const toggle = document.querySelector('.menu-toggle');
  if (drawer && backdrop && toggle) {
    const setMenu = (open) => {
      drawer.classList.toggle('open', open);
      backdrop.classList.toggle('show', open);
      toggle.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    };
    toggle.addEventListener('click', () => setMenu(true));
    drawer.querySelector('.drawer-close').addEventListener('click', () => setMenu(false));
    backdrop.addEventListener('click', () => setMenu(false));
    drawer.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setMenu(false)));
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') setMenu(false);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workbook-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.collection-nav--center').forEach((nav) => {
    const section = nav.closest('section');
    const grid = section && section.querySelector('.products');
    if (!grid) return;
    nav.addEventListener('click', async (e) => {
      const pill = e.target.closest('.collection-pill');
      if (!pill) return;
      e.preventDefault();
      nav.querySelectorAll('.collection-pill').forEach((p) => p.classList.remove('collection-pill--active'));
      pill.classList.add('collection-pill--active');
      grid.style.opacity = '0.4';
      try {
        const res = await fetch(pill.href);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('.shop .products');
        if (!next) throw new Error('grid missing');
        grid.replaceChildren(...next.children);
        grid.style.opacity = '';
      } catch (err) {
        window.location.href = pill.href;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
